import { useEffect, useState } from "react";
import {
  WifiOutlined,
  MonitorOutlined,
  DesktopOutlined,
} from "@ant-design/icons";
import { io } from "socket.io-client";

const SOCKET_SERVER_URL = "YOUR_SOCKET_URL";
const DEFAULT_APP_URL = "/poscutomerscreen"; // 👈 change this

function POSCustomerScreenButton() {
  // 🖥️ Function to open the default app URL in a new tab
  const openDefaultPath = () => {
    window.open(DEFAULT_APP_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      style={{
        float: "right",
        marginRight: "10px",
        display: "flex",
        gap: "10px",
      }}
    >
      {/* Monitor button */}
      <button onClick={openDefaultPath}>
        <DesktopOutlined />
      </button>
    </div>
  );
}

export default POSCustomerScreenButton;
